/*
 * @Description: 存塘概览-育苗
 * @Author: zcy
 * @Date: 2022-01-10 15:20:58
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-07-14 15:04:47
 */
import http from "@/axios/index";
/**接口根路经标识 */

// --------------------------实时存塘量
export function initPageList(data) {
  const url = `/mdtPondStockGroup/searchMdtPondStockGroupList`
  return http.post(url, data)
}


// --------------------------月存塘成本
export function monthInitPageList(data) {
  const url = `/midCostTotalGroup/getMonthlyStoragePondCost`
  return http.post(url, data)
}

// 获取所有区域--实时存塘量
export function getAllJiGou(data) {
  const url = `/mdtPondStockGroup/getGroupConditions`
  return http.post(url, data)
}

// 获取所有造次--实时存塘量
export function getAllPiCi(data) {
  const url = `/mdtPondStockGroup/getperiodConditions`
  return http.post(url, data)
}
// 获取所有品类--实时存塘量
export function getAllPinLei(data) {
  const url = `/mdtPondStockGroup/getTypeConditions`
  return http.post(url, data)
}
// 获取所有品种--实时存塘量
export function getAllPinZhong(data) {
  const url = `/mdtPondStockGroup/getBreedConditions`
  return http.post(url, data)
}

// 获取全部区域--月存塘成本
export function getAllJiGouMonth(data) {
  const url = `/midCostTotalGroup/getGroupConditions`
  return http.post(url, data)
}

// 获取全部造次--月存塘成本
export function getAllPiCiMonth(data) {
  const url = `/midCostTotalGroup/getPeriodConditions`
  return http.post(url, data)
}
// 获取全部品类--月存塘成本
export function getAllPinLeiMonth(data) {
  const url = `/midCostTotalGroup/getTypeConditions`
  return http.post(url, data)
}
// 获取全部品种--月存塘成本
export function getAllPinZhongMonth(data) {
  const url = `/midCostTotalGroup/getBreedConditions`
  return http.post(url, data)
}


// 跳转表部分接口-------------------------------------------------接口列表
// 获取权限下所有养殖场
export function getBaseListsByUser() {
  const url = '/baseData/queryBaseDataListByRole';
  return http.get(url);
}

// 获取养殖场下所有养殖区域
export function queryBaseGroupList(baseId) {
  const param = {
    baseId,
    groupFlag: 0
  }
  const url = '/baseGroup/queryBaseGroupList';
  return http.post(url, param)
}

// 根据当前机构id获取顶级机构id（为了获取养殖品种）
export function getOrgInfoByOrgId(orgId) {
  const url = '/org/getParentOrg/' + orgId;
  return http.get(url)
}

// 根据顶级机构id获取到养殖品种
export function getBreedCategory(orgId) {
  const url = '/breedData/getListMap/orgId/' + orgId;
  return http.get(url)
}


// 根据养殖区域获取养殖单元
export function listDataPermissionBoxData(groupId) {
  const url = '/boxData/listDataPermissionBoxData/' + groupId;
  return http.get(url)
}

// 采样记录部分接口-------------------------------------------------结束
// 采样记录获取列表分页接口
export function samplingInitPageList(data) {
  const url = '/growSampling/getListByPage';
  return http.post(url, data);
}


// 采样记录获取图表数据
export function samplingInitChartData(data) {
  const url = '/growSampling/line';
  return http.post(url, data);
}

// 箱养殖动态部分接口----------------------------------------------结束
// 获取养殖场下生产造次
export function getBatchList(orgId) {
  const url = '/periodData/getByBaseIdPeriod/' + orgId;
  return http.get(url);
}
// 根据字典获取养殖阶段列表
export function getDictionarysByType(type) {
  const url = '/sysDictionary/getListMap/type/' + type;
  return http.get(url);
}
// 箱养殖动态获取列表数据接口
export function getListByPages(data) {
  const url = '/outBoxData/getOutBoxDataListMap';
  return http.post(url, data);
}

// 养成存塘成本统计列表接口--------------------------------------------结束
// 存塘成本统计列表根据养殖场获取成本日期
export function getSsessmentOfCostMonthlySummary(baseId) {
  const url = '/checkBatchDay/getBoxFy/' + baseId;
  return http.get(url);
}
// 根据字典获取养殖阶段
export function getDictionarysByTypeYc(type) {
  const url = '/sysDictionary/getListMap/type/' + type;
  return http.get(url);
}
// 获取所有可用养殖品类
export function getBreedTypeList(baseId) {
  const url = '/breedData/getBreedType/' + baseId;
  return http.get(url);
}

// 根据成本日期获取当前养殖场可选择日期区间
export function getYearCheckDate(baseId, year) {
  const url = '/manageDesktop/getYearCheckDate/' + baseId + '/' + year;
  return http.get(url);
}
// 根据机构id获取养殖造次
export function getBatchListYc(orgId) {
  const url = '/periodData/getByBaseIdPeriod/' + orgId;
  return http.get(url);
}

// 存塘成本统计列表
export function getTotalCostsListByPages(data) {
  const url = '/manageDesktop/getCostTotalListByPage';
  return http.post(url, data);
}

// 养成结转成本统计接口列表------------------------------------------结束
// 养成-成本概览-养成结转成本统计(跳转表)-获取所有操作类型
export function getSeedlingCostOfoperationType(baseId) {
  const url = '/outSaleCost/getOperationType/fish/' + baseId;
  return http.get(url);
}

// 养成-成本概览-养成结转成本统计(跳转表)-获取列表
export function getCostRecordsListByPages(data) {
  const url = '/outSaleCost/getOutSaleCostListMap';
  return http.post(url, data);
}

// 养成-养成养殖利润与指标分析(跳转表)-接口列表-------------------------结束
// 获取权限下汇总类型(养成养殖理论与指标分析跳转表)
export function getGroupTypeList(groupId) {
  const url = '/outSaleAnalysis/getOutSaleGroupByTypeList';
  return http.get(url);
}
// 根据养殖区域获取池塘类型
export function getboxTypeList(groupId) {
  const url = '/boxData/searchPatternValue/' + groupId;
  return http.get(url);
}

// 养成-养成养殖利润与指标分析(跳转表)
export function getListByPagesYc(data) {
  const url = '/outSaleAnalysis/getOutSaleAnalysisListMap';
  return http.post(url, data);
}

/**
 * @Author: lishiqiao
 * @Date: 2022-06-02 15:40:33
 * @description: 获取成本统计明细表-操作类型下拉列表
 */
export function getCostOfTypeList() {
  const url = '/checkBatchDay/getOperationType';
  return http.get(url);
}

/**
 * @Author: lishiqiao
 * @Date: 2022-06-02 15:45:30
 * @description: 养成存塘成本统计明细表分页
 * @param {*} params
 */
export function getPageOfCostRecordsDetails(params) {
  const url = '/checkBatchDay/getCheckBatchDayListMap';
  return http.post(url, params);
}

/**
 * @Author: lishiqiao
 * @Date: 2022-07-14 11:51:55
 * @description: 获取养殖阶段
 * @param {*} type
 */
export function getBreedingStageList(type) {
  const url = '/sysDictionary/getListMap/type/' + type;
  return http.get(url);
}

/**
 * @Author: lishiqiao
 * @Date: 2022-07-14 13:57:45
 * @description: 获取考核期列表
 * @param {*} baseId
 */
export function getAssessmentList(baseId) {
  const url = '/checkBatchDay/getBoxFy/' + baseId;
  return http.get(url);
}